// routes
import Router from "./routes";
// theme
import ThemeProvider from "./theme";
// components
import ThemeSettings from "./components/settings";
import { ChartStyle } from "./components/chart";
import ScrollToTop from "./components/ScrollToTop";
import { ProgressBarStyle } from "./components/ProgressBar";
import NotistackProvider from "./components/NotistackProvider";
import MotionLazyContainer from "./components/animate/MotionLazyContainer";
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import TagManager from "react-gtm-module";

// ----------------------------------------------------------------------

export default function App() {
  const tagManagerArgs = {
    gtmId: "GTM-NCBPHGL",
  };
  TagManager.initialize(tagManagerArgs);
  window.dataLayer.push({
    event: "pageview",
  });
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <NotistackProvider>
            <ProgressBarStyle />
            <ChartStyle />
            <ScrollToTop />
            <Router />
            <NotificationContainer />
          </NotistackProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
